import * as types from './authActionTypes';
import * as userTypes from './../user/userActionTypes';

const initialState = {
    isAuthInitialized: false, // used for validating auto reconnection when page is refreshed
    isUserSignedIn: false,
    isSubscriber: true,
    subcriptionCheckInProgress: false,
    hasError: false,
    errorMessage: '',
    errorCode:'',
    uid: 0
};

const loginSuccess = (state, action) => {
    const { uid } = action;
    return {
        ...state,
        isAuthInitialized: true,
        isUserSignedIn: true,
        uid,
        hasError: false,
        errorMessage: ''
    };
}

const logoutSuccess = (state, action) => {
    return {
        ...state,
        isAuthInitialized: true,
        isUserSignedIn: false,
        uid: 0,
        hasError: false,
        errorMessage: ''
    };
}

const createUserSuccess = (state, action) => {
    const { userId } = action;
    return {
        ...state,
        isUserSignedIn: true,
        uid: userId,
        hasError: false,
        errorMessage: ''
    }; 
}

const error = (state, action) => {
    const { errorMessage } = action;
    return {
        ...state,
        isAuthInitialized: true,
        hasError: true,
        errorMessage
    };
}

const removeError = (state, action) => {
    return {
        ...state,
        hasError: false,
        errorMessage: '',
        errorCode:'',
    }
}

const checkSubscriptionStatusSuccess = (state, action) => {
    return {
        ...state,
        isSubscriber: action.isSubscriber,
        subcriptionCheckInProgress: false,
        hasError: false,
        errorMessage: '',
        errorCode:'',
    }
}

const checkSubscriptionStatusStart = (state, action) => {
    return {
        ...state,
        isSubscriber: true,
        subcriptionCheckInProgress: true,
        hasError: false,
        errorMessage: '',
        errorCode:'',
    }
}

export const auth = (state = initialState, action) => {
  switch(action.type) {
    //SIGNIN
    case types.LOGIN_SUCCESS:                    return loginSuccess(state, action);  
    case types.LOGIN_ERROR:                      return error(state, action);
    case types.REMOVE_ERROR:                     return removeError(state, action);
        
    //LOGOUT
    case types.LOGOUT_SUCCESS:                   return logoutSuccess(state, action);
    case types.LOGOUT_ERROR:                     return error(state, action);
        
    //CREATEUSER_SUCCESS
    case userTypes.CREATEUSER_SUCCESS:           return createUserSuccess(state, action);

    //Retrieve Subscription Status
    case types.RETRIEVE_SUBSCRIPTION_START:      return checkSubscriptionStatusStart(state, action);  
    case types.RETRIEVE_SUBSCRIPTION_SUCCESS:    return checkSubscriptionStatusSuccess(state, action);  
    case types.RETRIEVE_SUBSCRIPTION_FAIL:       return error(state, action); 

    //ERROR
    case types.ERROR:                            return error(state, action);
         
    default:                                     return state;
  }
}

export default auth;


// WEBPACK FOOTER //
// ./src/components/Auth/authReducers.js